import { render, staticRenderFns } from "./SupplierOthersMaintain.vue?vue&type=template&id=4f5258fc&scoped=true"
import script from "./SupplierOthersMaintain.vue?vue&type=script&lang=js"
export * from "./SupplierOthersMaintain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5258fc",
  null
  
)

export default component.exports